import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowseBannerComponent } from './components/browse-banner/browse-banner.component';
import { BrowseContainerComponent } from './components/browse-container/browse-container.component';
import { BrowseContainerRoutingModule } from './browse-campaign-routing.module';
import { CategoryFiltersComponent } from './components/category-filters/category-filters.component';
import { WidgetWrapperComponent } from './components/widget-wrapper/widget-wrapper.component';
import {
  NgAisInstantSearchModule, NgAisInfiniteHitsModule, NgAisSearchBoxModule,
  NgAisClearRefinementsModule, NgAisConfigureModule
} from 'angular-instantsearch';
import { FundraiserFilterComponent } from './components/fundraiser-filter/fundraiser-filter.component';
import { FormsModule } from '@angular/forms';
import { HomepageService } from '../shared/services/homepage/homepage.service';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { BrowsePlaceholderComponent } from './components/browse-placeholder/browse-placeholder.component';
import { CustomFilterComponent } from './components/custom-filter/custom-filter.component';
import { SipNudgeComponent } from './components/sip-nudge/sip-nudge.component';
import { SharedModule } from '../shared/shared.module';
import { SipDockComponent } from './components/sip-dock/sip-dock.component';
import { ChatWithUsModule } from '../common/chat-with-us/chat-with-us.module';
import { CommonHeaderModule } from '../common/common-header/common-header.module';
import { CommonTalktousModalModule } from '../common/common-talktous-modal/common-talktous-modal.module';
import { FbShareModule } from '../common/fb-share/fb-share.module';
import { FooterModule } from '../common/footer/footer.module';
import { ModuleLoaderModule } from '../common/module-loader/module-loader.module';
import { WhatsappShareModule } from '../common/whatsapp-share/whatsapp-share.module';
import { WidgetModule } from '../common/widget/widget.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { InViewportModule } from 'ng-in-viewport';
import { SigninSignupComponent } from '../core/signin-signup/signin-signup.component';
import { BasicButtonComponent } from '../core/basic-button/basic-button.component';
import { FundraiserCardComponent } from '../core/fundraiser-card/fundraiser-card.component';
import { FundraiserRandomCardComponent } from '../core/funraiser-random-card/fundraiser-random-card.component';
@NgModule({
  declarations: [
    BrowseContainerComponent,
    CategoryFiltersComponent,
    WidgetWrapperComponent,
    FundraiserFilterComponent,
    BrowsePlaceholderComponent,
    CustomFilterComponent,
    SipNudgeComponent,
    SipDockComponent
  ],
  imports: [
    CommonModule,
    BrowseBannerComponent,
    BrowseContainerRoutingModule,
    CommonHeaderModule,
    FooterModule,
    WhatsappShareModule,
    FbShareModule,
    ChatWithUsModule,
    NgAisInstantSearchModule.forRoot(),
    NgAisInfiniteHitsModule,
    NgAisSearchBoxModule,
    NgAisClearRefinementsModule,
    NgAisConfigureModule,
    FormsModule,
    WidgetModule,
    SwiperModule,
    CommonTalktousModalModule,
    ModuleLoaderModule,
    MatButtonModule,
    SharedModule,
    MatChipsModule,
    MatMenuModule,
    MatIconModule,
    MatRadioModule,
    MatDialogModule,
    InViewportModule,
    SigninSignupComponent,
    BasicButtonComponent,
    FundraiserCardComponent,
    FundraiserRandomCardComponent
],
  providers: [
    HomepageService
  ]
})
export class BrowseCampaignModule { }
